import React from 'react';
import { observer } from 'mobx-react';
/* eslint import/no-cycle: "off" */
import BlankPageLayout from './BlankPageLayout';
import MaxWidth from './Helper/MaxWidth';

interface Props {
  children: React.ReactNode;
  title?: string;
  headline?: string;
  maxWidth?: string;
  padding?: string;
  className?: string;
}

const PageLayout = observer((props: Props) => {
  return (
    <BlankPageLayout title={props.title} className={props.className}>
      <div>
        <MaxWidth
          style={{ maxWidth: props.maxWidth, padding: props.padding }}
          className={'maxWidth-container'}
        >
          <div className="px-0 backgroundContainer-box">{props.children}</div>
        </MaxWidth>
      </div>
    </BlankPageLayout>
  );
});

export default PageLayout;
